"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const enum_1 = require("../enum");
const dnsSchema = new mongoose_1.Schema({
    name: {
        type: String,
        required: true,
    },
    ttl: {
        type: Number,
        default: 3600,
    },
    type: {
        type: String,
        enum: Object.values(enum_1.DNS_TYPE),
        required: true,
    },
    value: {
        type: String,
        required: true,
    },
    domain: {
        type: mongoose_1.Schema.Types.ObjectId,
        ref: "Domain",
        required: true,
    },
});
exports.default = (0, mongoose_1.model)("Dns", dnsSchema);
